import { render, staticRenderFns } from "./BaseSmallConfirm.vue?vue&type=template&id=3e3d8716&scoped=true"
import script from "./BaseSmallConfirm.vue?vue&type=script&lang=js"
export * from "./BaseSmallConfirm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e3d8716",
  null
  
)

export default component.exports